
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({
  components: {},
  filters,
})
export default class SingleImage4 extends Vue {
  @Prop({ default: null })
  private image!: any;
}
